// NotFoundPage.tsx
import { Link } from "react-router-dom";
import { Home, ArrowLeft, GraduationCap, BookOpen, Users, MessageCircle } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50/30">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="max-w-sm mx-auto text-center">
          {/* 404 Number */}
          <div className="mb-3">
            <h1 className="text-6xl font-black tracking-tighter md:text-7xl">
              <span className="text-transparent bg-gradient-to-r from-orange-500 to-orange-600 bg-clip-text">
                4
              </span>
              <span className="text-transparent bg-gradient-to-r from-orange-400 to-orange-500 bg-clip-text">
                0
              </span>
              <span className="text-transparent bg-gradient-to-r from-orange-600 to-orange-700 bg-clip-text">
                4
              </span>
            </h1>
          </div>

          {/* Content */}
          <div className="space-y-1">
            <h2 className="text-lg font-bold text-gray-900 md:text-xl">
              Page Not Found
            </h2>
            <p className="text-sm text-gray-600">
              The page you're looking for doesn't exist or might have been moved. Please check the URL or return to the homepage.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-2 mt-5 sm:flex-row sm:justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-white transition-all bg-gradient-to-r from-orange-600 to-orange-500 rounded-lg hover:shadow-lg hover:scale-105"
            >
              <Home className="w-4 h-4" />
              Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-medium text-gray-700 transition-all bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300"
            >
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </button>
          </div>

          {/* Quick Navigation Links */}
          <div className="flex flex-wrap justify-center gap-1.5 mt-5 pt-4 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-md hover:border-orange-300 hover:text-orange-600 transition-all"
            >
              <Home className="w-3 h-3" />
              Home
            </Link>
            <Link
              to="/courses"
              className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-md hover:border-orange-300 hover:text-orange-600 transition-all"
            >
              <BookOpen className="w-3 h-3" />
              Courses
            </Link>
            <Link
              to="/mentorship"
              className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-md hover:border-orange-300 hover:text-orange-600 transition-all"
            >
              <Users className="w-3 h-3" />
              Mentorship
            </Link>
            <Link
              to="/forums"
              className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-md hover:border-orange-300 hover:text-orange-600 transition-all"
            >
              <MessageCircle className="w-3 h-3" />
              Forums
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-md hover:border-orange-300 hover:text-orange-600 transition-all"
            >
              <GraduationCap className="w-3 h-3" />
              About
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;